import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { Dumbbell, Apple, Moon, Brain, Users, HeartPulse, ArrowRight, CheckCircle } from "lucide-react";

const TIP_ICONS = [Dumbbell, Apple, Moon, Brain, Users, HeartPulse];

export default function LifestylePage() {
  const { t } = useLanguage();
  const lifestyle = t("lifestyle");

  if (typeof lifestyle !== 'object') return null;

  return (
    <div className="min-h-screen pt-20">
      <section className="py-20 bg-[#F4F1EA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center space-y-4">
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#4A6753]">{lifestyle.overline}</span>
          <h1 data-testid="lifestyle-page-title" className="font-heading text-4xl sm:text-5xl tracking-tight text-[#1E2922] font-semibold">
            {lifestyle.title}
          </h1>
          <p className="text-base leading-relaxed text-[#566D60] max-w-2xl mx-auto">{lifestyle.intro}</p>
        </div>
      </section>

      {/* Lifestyle Tips */}
      <section className="py-24 bg-[#FDFBF7]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {Array.isArray(lifestyle.tips) && lifestyle.tips.map((tip, i) => {
              const Icon = TIP_ICONS[i] || HeartPulse;
              return (
                <div key={i} data-testid={`lifestyle-tip-${i}`} className="bg-[#F4F1EA] rounded-2xl p-8 border border-transparent hover:border-[#E2E0D9] transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-md">
                  <div className="w-14 h-14 rounded-xl bg-[#4A6753]/10 flex items-center justify-center mb-6">
                    <Icon size={28} className="text-[#4A6753]" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-medium text-[#1E2922] mb-3 font-heading">{tip.title}</h3>
                  <p className="text-sm leading-relaxed text-[#566D60]">{tip.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Lifestyle Services */}
      <section className="py-24 bg-[#F4F1EA]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 space-y-8">
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight text-[#1E2922] text-center">
            {t("services.overline")}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {Array.isArray(lifestyle.lifestyle_services) && lifestyle.lifestyle_services.map((service, i) => (
              <div key={i} data-testid={`lifestyle-service-${i}`} className="flex items-start gap-3 bg-white rounded-xl p-4 border border-[#E2E0D9]">
                <CheckCircle size={16} className="text-[#4A6753] mt-0.5 shrink-0" />
                <span className="text-sm text-[#566D60] leading-relaxed">{service}</span>
              </div>
            ))}
          </div>
          <div className="text-center pt-4">
            <Link to="/contact" data-testid="lifestyle-contact-link" className="inline-flex items-center gap-2 bg-[#4A6753] text-white rounded-full px-8 py-3.5 font-medium hover:bg-[#3A5242] transition-colors shadow-sm">
              {t("hero.cta")} <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
